/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG
import { UNSAFE_noExposureExp, expValEquals } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';
import { fg } from '@atlassian/jira-feature-gating';

// Add your feature flag name as a constant
const ERROR_TRACKING_ENABLED = 'fe.platform.error.tracking.enabled';

const CRITICAL_QUERY_WITH_RELAY = 'jsw.perf.critical-backlog-with-relay';
const BACKLOG_WITH_RELAY_ENABLED = 'jsw.perf.critical-backlog-with-relay';
const EMIT_APDEX_ON_ANIMATION_FRAME = 'jsw.perf.board-backlog-emit-apdex-on-animation-frame';

const UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';

export const JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT = 'jsw_sprint_planning_whiteboards';

// Add your feature flag constant to this list so that it can be picked up by cypress tests and storybook
export const backlogFeatureFlagNames: string[] = [
	ERROR_TRACKING_ENABLED,
	CRITICAL_QUERY_WITH_RELAY,
	BACKLOG_WITH_RELAY_ENABLED,
	EMIT_APDEX_ON_ANIMATION_FRAME,
	'modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl',
	UIF_STATSIG_EXPOSURES_UPDATES,
	JSW_SPRINT_PLANNING_WHITEBOARDS_ENTRYPOINT,
];

export const isErrorTrackingEnabledWithSentry = (): boolean =>
	ff('fe.platform.error.tracking.enabled');

export const isRelayQueryEnabled = () => ff('jsw.perf.critical-backlog-with-relay');

export const isBacklogWithRelayEnabled = () => ff('jsw.perf.critical-backlog-with-relay');

export const emitApdexOnAnimationFrame = () =>
	ff('jsw.perf.board-backlog-emit-apdex-on-animation-frame');

// <tjoy>
// eslint-disable-next-line jira/ff/inline-usage
export function isInAddPeopleButtonOpenTMPExperimentCohort(): boolean {
	return expValEquals('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
}
// </tjoy>

export const isEpicPanelInProgressBarTooltipsUpdateEnabled = () =>
	ff('modify-cmp-backlog-epic-panel-in-progress-bar-tooltips_gusjl');

// <jyan>
// </jyan>

// eslint-disable-next-line jira/ff/inline-usage
export const isViewSettingAsPanelExpEnabledWithNoExposure = () =>
	fg('jira_view_settings_additional_fields');
